import { DictResType } from "@/api/global/dict/types";
import { LevelIconType } from "@/api/global/levelIcon/types";
import { storeMallOrderInfo } from "@/api/mallModule/confirmOrder/types";
interface stateType {
  isShowLoading: boolean;
  appData: GlobalAppDataType;
  keepAliveInclude: string[];
  tabbarIndex: number;
  androidChannel: number;
  keyStr: string; //加密过后的对称密钥
  keyInfo: any //加密过后的对称密钥的导入
  headerInfo: {
    "c-id": string;
    "c-meta": string;
  };
  isRefreshAppInputToken: boolean;
  allDict: DictResType[];
  levelIconList: LevelIconType[];
  mallConfirmOrder: storeMallOrderInfo;
  phoneStatusBarHeight: number;
  safeAreaBottomHeight: number;
  auditReason: string;
  isClickAgreement: boolean;
  isShowNewSource: boolean
  isShowRedEnvolopeEntrance: boolean
  ossBaseHref: string
}

export const state: () => stateType = () => {
  return {
    isShowLoading: false, //显示loading
    appData: {
      lng: "",
      lat: "",
      token: "",
      secret: "",
      session: "",
      os: "",
      cid: "",
      cmeta: "",
      userType: 2,
      userId: "",
      tecName: "",
      tecAvator: "",
      cityCode: "",
      directlyResponsible: {
        name: '',
        type: 0,
      },
      describeVerifyResult: {
        name: '',
        type: 0,
      },
      user: {
        os: "",
        services: {
          scope: -1,
        },
        privacy: {
          name: '',
          isAutomaticReceipt: 0,
        },
        isOnline: 1,
        userType: 2,
      },
      phone: "",
      isAgent: 0,
      carfreeRedPoint: 0
    }, //核心数据
    keepAliveInclude: [
      "myOrders",
      "technicianList",
      "tabModuleIndex",
      "tabModuleServiceIndex",
      "tabModuleMyIndex",
      "inviteDetail",
      "techExposurePackageIndex",
      "techExposurePackageRecord"
    ], //include
    tabbarIndex: 0, //底部tabbar选中索引
    androidChannel: 0, //审核平台来源，0：默认，1：华为， 2：应用宝， 3：小米， 4：oppo， 5：vivo  6：三星
    keyStr: "",
    keyInfo: null,
    headerInfo: {
      "c-id": "",
      "c-meta": "",
    },
    isRefreshAppInputToken: false,
    allDict: [
      {
        code: "",
        infoList: [],
        name: "",
        remarks: "",
      },
    ],
    levelIconList: [],
    mallConfirmOrder: {
      products: [],
    },
    phoneStatusBarHeight: 40,
    safeAreaBottomHeight: 0,
    auditReason: '',
    isClickAgreement: false,
    isShowNewSource: false,
    isShowRedEnvolopeEntrance: false,
    ossBaseHref: '' // OSS公有空间基准URL
  };
};
